<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <nav aria-label="Progress">
        <ol role="list" class="border border-gray-300 rounded-md divide-y divide-gray-300 md:flex md:divide-y-0">
            <li v-for="(step, stepIdx) in steps" :key="step.name" class="relative md:flex-1 md:flex" @click="selectStep(step)">
                <a v-if="step.status === 'complete'" :href="step.href" class="group flex items-center w-full">
          <span class="px-6 py-4 flex items-center text-sm font-medium">
            <span
                class="flex-shrink-0 w-5 h-5 flex items-center justify-center bg-indigo-600 rounded-full group-hover:bg-indigo-800">
              <CheckIcon class="w-3 h-3 text-white" aria-hidden="true"/>
            </span>
            <span class="ml-4 text-sm font-medium text-gray-900">{{ step.name }}</span>
          </span>
                </a>
                <a v-else-if="step.status === 'current'" :href="step.href"
                   class="px-6 py-4 flex items-center text-sm font-medium" aria-current="step">
          <span class="flex-shrink-0 w-5 h-5 flex items-center justify-center border-2 border-indigo-600 rounded-full">
          </span>
                    <span class="ml-4 text-sm font-medium text-indigo-600">{{ step.name }}</span>
                </a>
                <a v-else :href="step.href" class="group flex items-center">
          <span class="px-6 py-4 flex items-center text-sm font-medium">
            <span
                class="flex-shrink-0 w-5 h-5 flex items-center justify-center border-2 border-gray-300 rounded-full group-hover:border-gray-400">
            </span>
            <span class="ml-4 text-sm font-medium text-gray-500 group-hover:text-gray-900">{{ step.name }}</span>
          </span>
                </a>
                <template v-if="stepIdx !== steps.length - 1">
                    <!-- Arrow separator for lg screens and up -->
                    <div class="hidden md:block absolute top-0 right-0 h-full w-5" aria-hidden="true">
                        <svg class="h-full w-full text-gray-300" viewBox="0 0 22 80" fill="none"
                             preserveAspectRatio="none">
                            <path d="M0 -2L20 40L0 82" vector-effect="non-scaling-stroke" stroke="currentcolor"
                                  stroke-linejoin="round"/>
                        </svg>
                    </div>
                </template>
            </li>
        </ol>
    </nav>
</template>

<script>
import {CheckIcon} from '@heroicons/vue/24/solid'

const steps = [
    {id: 1, name: 'Тип', href: '#', status: 'upcoming'},
    {id: 2, name: 'Настройка', href: '#', status: 'upcoming'},
    {id: 3, name: 'Дизайн', href: '#', status: 'upcoming'},
]

export default {
    props: {
        currentStepId: {
            required: true
        }
    },

    components: {
        CheckIcon,
    },

    watch: {
        currentStepId() {
            this.refreshState()
        }
    },

    mounted() {
        this.refreshState()
    },

    data() {
        return {
            steps,
        }
    },

    methods: {
        selectStep(step) {
            this.$emit('selectStep', step.id)
        },

        refreshState() {
            this.steps.forEach(item => {
                if (item.id === this.currentStepId) {
                    item.status = 'current'
                } else if (item.id > this.currentStepId) {
                    item.status = 'upcoming'
                } else {
                    item.status = 'complete'
                }
            })
        }
    }
}
</script>
